import { useEffect, useState } from "react";
import { useUser } from "contexts/userContext/userContext.js";
import { strongPassRegex } from "helpers/validators.js";

// !!! updates password requirements to strong depends on user settings

type UpdatePasswordRequirementsArgs = {
  defaultFields: any;
  fieldName: string;
  confirmField?: string;
  enforceStrongPass?: boolean;
};

const useUpdatePasswordRequirements = ({
  defaultFields,
  fieldName,
  confirmField,
  enforceStrongPass,
}: UpdatePasswordRequirementsArgs) => {
  const [formFields, setFormFields] = useState(defaultFields);
  const { getUserData } = useUser();

  const validation = {
    required: true,
    invalidMessage: "signin-password-tooltip-text",
    reg: strongPassRegex,
  };

  useEffect(() => {
    if (enforceStrongPass || getUserData()?.EnforceStrongPass) {
      setFormFields((prev: any) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          tooltip: prev[fieldName].tooltip
            ? {
                text: "signin-password-tooltip-text",
              }
            : null,
          validation,
        },
        ...(confirmField
          ? {
              [confirmField]: {
                ...prev[confirmField],
                validation,
              },
            }
          : null),
      }));
    }
  }, [getUserData()?.EnforceStrongPass, enforceStrongPass]);

  return formFields;
};

export default useUpdatePasswordRequirements;
